import { format } from 'date-fns';
import { type } from 'jquery';
import moment from 'moment';
import { infraStructureConstants } from '../constants';
import { infraStructureService } from '../services';
import { alertActions } from './alert.actions';

export const infraStructureActions = {
    getInfraStructure,
    deleteInfraStructure,
    postInfraStructure,
    setNewInfraStructure,
    setNewAssociation,
    postNewAssociation,
    editInfraStructure,
    clearInfrastructures,
    getByName,
    getDetails,
    setFilters,
    getLocals,
    getOccupationAreas,
    getAssociation,
    clearAssociations,
    setUniqueNewAssociation,
    deleteDefaultAssociation,
    deleteNewAssociation,
    setUpdateDefaultAssociation,
    sendUpdatedDefaultAssociation
};

function formatPayload(data) {
    const formatType = (type) => {
        switch (type) {
            case 'local':
                return 'local';
            case 'occupationArea':
                return 'area_de_atuacao';
            case 'businessUnit':
                return 'unidade_de_negocio';
            default:
                return '';
        };
    };

    const reports = data.map(({ name, _id, type, createdAt }) => {
        const timestamp = moment(new Date(parseInt(_id.toString().substring(0, 8), 16) * 1000))
            .format("DD/MM/YYYY");
        return {
            id: _id,
            name,
            created_at: createdAt ? moment(new Date(createdAt)).format("DD/MM/YYYY") : timestamp,
            label: formatType(type),
            type: type,
        }
    });
    return reports;
};

function getInfraStructure({ page, limit, types }) {
    return (dispatch) => {
        dispatch({
            type: infraStructureConstants.REQUEST_INFRASTRUCTURE
        })

        infraStructureService.getInfraStructure(page, limit, types)
            .then(response => {
                dispatch({
                    type: infraStructureConstants.GET_INFRASTRUCTURE,
                    payload: {
                        paging: response.paging,
                        infras: formatPayload(response.infras)
                    }
                });
            })
            .catch(err => {
                dispatch({
                    type: infraStructureConstants.FAILURE_INFRASTRUCTURE
                });
            });
    };

};


function setNewInfraStructure({ type, name }) {
    return (dispatch) => {
        dispatch(success({ type, name }));
    };

    function success(payload) {
        return { type: infraStructureConstants.SET_NEW_INFRASTRUCTURE, payload };
    };
};

function postInfraStructure({ type, body }) {
    return (dispatch) => {
        dispatch(request({ type }));
        infraStructureService.postInfraStructure(type, body).then(({ data }) => {
            const dataList = []
            dataList.push(data)
            dispatch(success({ type, data: formatPayload(dataList, type) }));
            dispatch(alertActions.success('Cadastro de infraestrutura realizado!'))

        }).catch((error) => {
            dispatch(failure({ type }));
            dispatch(alertActions.error('Erro no cadastro da infraestrutura.'))
            console.log(error);
        });
    };

    function request(payload) {
        return { type: infraStructureConstants.REQUEST_POST_INFRASTRUCTURE, payload };
    };

    function success(payload) {
        return { type: infraStructureConstants.POST_INFRASTRUCTURE, payload };
    };

    function failure(payload) {
        return { type: infraStructureConstants.FAILURE_POST_INFRASTRUCTURE, payload };
    };
};

function deleteInfraStructure({ type, id }) {
    return (dispatch) => {
        dispatch(request());
        infraStructureService.deleteInfraStructure(type, id).then(() => {
            dispatch(success({ id }));
        }).catch((error) => {
            dispatch(failure());
            console.log(error);
        });
    };

    function request() {
        return { type: infraStructureConstants.REQUEST_DELETE_INFRASTRUCTURE }
    };

    function success(payload) {
        return { type: infraStructureConstants.DELETE_INFRASTRUCTURE, payload }
    };

    function failure() {
        return { type: infraStructureConstants.FAILURE_DELETE_INFRASTRUCTURE }
    };
};

function setNewAssociation({ businessUnit, local, occupationArea, associationId }) {
    return (dispatch) => {
        dispatch(success({ businessUnit, local, occupationArea, associationId }));
    };

    function success(payload) {
        return { type: infraStructureConstants.SET_NEW_ASSOCIATION, payload };
    };
};

function postNewAssociation(associations) {
    return (dispatch) => {
        dispatch(request());
        infraStructureService.postNewAssociation(associations).then((_data) => {
            dispatch(success())
            dispatch(alertActions.success('Os vinculos foram salvos!'))
        }).catch((error) => {
            console.log(error);
            dispatch(alertActions.error(''))
            dispatch(failure());
        });
    };

    function request() {
        return { type: infraStructureConstants.REQUEST_POST_ASSOCIATION }
    };

    function success() {
        return { type: infraStructureConstants.POST_ASSOCIATION }
    };

    function failure() {
        return { type: infraStructureConstants.FAILURE_POST_ASSOCIATION }
    };
};

function editInfraStructure({ type, id, name }) {
    return (dispatch) => {
        dispatch(request())
        infraStructureService.editInfraStructures(type, id, { name }).then((data) => {
            dispatch(alertActions.success('A edição dos dados foi salva!'))
            dispatch(success({ id, name }))
        }).catch(error => {
            console.log(error);
            dispatch(alertActions.error('Erro na Edição de dados.'))
            dispatch(failure())
        });
    };

    function request() {
        return { type: infraStructureConstants.REQUEST_PUT_INFRASTRUCTURE }
    };

    function success(payload) {
        return { type: infraStructureConstants.PUT_INFRASTRUCTURE, payload }
    };

    function failure() {
        return { type: infraStructureConstants.FAILURE_PUT_INFRASTRUCTURE }
    };
};

function getByName({ name }) {
    return (dispatch) => {
        dispatch(request());
        infraStructureService.getByName(name).then(data => {
            dispatch(success({ paging: data.paging, infras: formatPayload(data.infras) }));
        }).catch((error) => {
            dispatch(failure());
            console.log(error);
        });
    };

    function request() {
        return { type: infraStructureConstants.REQUEST_INFRASTRUCTURE };
    };

    function success(payload) {
        return { type: infraStructureConstants.GET_INFRASTRUCTURE, payload };
    };

    function failure() {
        return { type: infraStructureConstants.FAILURE_INFRASTRUCTURE };
    };
};

function clearInfrastructures() {
    return (dispatch) => dispatch(success());

    function success() {
        return { type: infraStructureConstants.CLEAR_INFRASTRUCTURES };
    };
};


function getDetails({ infra }) {
    return dispatch => {
        dispatch({ type: infraStructureConstants.REQUEST_SET_DETAILS });
        infraStructureService.getAssociation(infra.id).then(data => {
            dispatch({ type: infraStructureConstants.SET_DETAILS, payload: { ...infra, associations: data } })
        }).catch(err => {
            console.log(err);
            dispatch({ type: infraStructureConstants.FAILURE_SET_DETAILS });
        });
    };
};

function getAssociation(id) {
    return dispatch => {
        dispatch({ type: infraStructureConstants.REQUEST_DEFAULT_ASSOCIATIONS });
        infraStructureService.getAssociation(id)
            .then((data) => {
                dispatch({ type: infraStructureConstants.GET_ASSOCIATIONS_SUCCESS });
                const associations = !!data.length ? data
                    .map(({ businessUnit, local, occupationArea, _id }) => ({ businessUnit, local, occupationArea, associationId: _id })) : [];
                !!associations.length && associations.forEach(({ businessUnit, local, occupationArea, associationId }) => {
                    const payload = { businessUnit, local, occupationArea, associationId };
                    dispatch({ type: infraStructureConstants.SET_DEFAULT_ASSOCIATIONS, payload });
                });
            })
            .catch(error => console.log(error))
    };
};

function setFilters(payload) {
    return dispatch => dispatch({ type: infraStructureConstants.SET_FILTERS, payload });
};

function getLocals() {
    return dispatch => {
        infraStructureService.getLocal()
            .then(data => dispatch({ type: infraStructureConstants.GET_LOCALS, payload: data }))
            .catch(err => {
                console.error(err);
                dispatch({ type: 'GET_LOCALS_ERROR' });
            });
    };
};


function getOccupationAreas() {
    return dispatch => {
        infraStructureService.getOccupationArea()
            .then(data => dispatch({ type: infraStructureConstants.GET_OCCUPATION_AREA, payload: data }))
            .catch(err => {
                console.error(err);
                dispatch({ type: 'GET_OCCUPATION_AREA_ERROR' });
            });
    };
};

function setUniqueNewAssociation({ type, associationId, infra }) {
    const payload = {
        associationId,
        infra,
        type
    };
    return dispatch => {
        dispatch({ type: infraStructureConstants.SET_UNIQUE_NEW_ASSOCIATION, payload });
    };
};

function sendUpdatedDefaultAssociation(assosciations) {
    return dispatch => {
        infraStructureService.updateAssociation(assosciations).then(() => dispatch({
            type: infraStructureConstants.SEND_ASSOCIATIONS_TO_UPDATE
        })).catch(error => {
            dispatch({ type: 'SEND_UPDATE_ASSOCIATION_FAILURE' });
            console.log(error);
        });
    };
};

function setUpdateDefaultAssociation({ type, associationId, infra }) {
    const payload = { type, associationId, infra };
    return dispatch => {
        dispatch({ type: infraStructureConstants.SET_ASSOCIATIONS_TO_UPDATE, payload });
    };
};

function clearAssociations() {
    return dispatch => dispatch({ type: infraStructureConstants.CLEAR_ASSOCIATIONS });
};

function deleteDefaultAssociation(id) {
    return dispatch => {
        infraStructureService.deleteAssociation(id)
            .then(() => dispatch({ type: infraStructureConstants.DELETE_DEFAULT_ASSOCIATION_SUCCESS, id }))
            .catch(error => console.log(error));
    };
};

function deleteNewAssociation(id) {
    return dispatch => {
        dispatch({ type: infraStructureConstants.DELETE_NEW_ASSOCIATION_SUCCESS, id })
    };
};

